import React, { useState, useEffect } from "react";
import axios from "axios";
import avatar from "../../../assets/images/default-user.webp";
import { use } from "react";

function AddFamilyDonor({ setShowForm, setData, data }) {
  const AuthToken = localStorage.getItem("AuthUser");

  const initialFormState = {
    name: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitAddFamilyDonor = async (e) => {
    e?.preventDefault();

    if (!formData.name.trim()) {
      setErrors({ name: "Name is required" });
      return;
    }

    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/store-family-donors`,
        formData
      );
console.log("Base URL:", process.env.REACT_APP_API_BASE_URL);

      console.log("response after adding family donor", response.data);
      setShowForm(false);


  setData((pre) => (
    {
     ...pre, 
        donors: [...pre.donors, response.data.donor] 
    
    }
    )
    );


    } catch (err) {
      console.error("Error adding family donor:", err);
    }
  };

  // useEffect(() => { 

  //   submitAddFamilyDonor();
  // }, [formData]);
  return (
    <form onSubmit={submitAddFamilyDonor} className="container">
      <h3 className="mb-4 text-center px-3">Add Family Donor</h3>

      <div className="row">
        <div className="col-md-12 d-flex flex-row gap-4 mx-auto">
          <div className="mb-3 w-50">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            <span className="text-danger">{errors.name}</span>
          </div>
          <div className="w-50 mt-4">
            <button type="submit" className="btn btn-success">
              Add Donor
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default AddFamilyDonor;
